import { render, staticRenderFns } from "./BotaoCategoria.vue?vue&type=template&id=c9977202&scoped=true"
import script from "./BotaoCategoria.vue?vue&type=script&lang=js"
export * from "./BotaoCategoria.vue?vue&type=script&lang=js"
import style0 from "./BotaoCategoria.vue?vue&type=style&index=0&id=c9977202&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9977202",
  null
  
)

export default component.exports